// extracted by mini-css-extract-plugin
export default {"main":"AdminCandidateChecks_main__2-jwv"};